import { EcoLabels } from '../../../../components/EcoLabel/EcoLabels';
import { FavoriteButton } from '../../../../components/Favorites/FavoriteButton';
import { Button } from '../../../../components/Form/Button';
import { QuantityInput } from '../../../../components/Form/QuantityInput';
import { Img } from '../../../../components/Img/Img';
import { PriceTagSimple, getSpecialPrice } from '../../../../components/PriceTagSimple/PriceTagSimple';
import { DeliveryTime } from '../../../../components/product/DeliveryTime';
import { useTranslation } from '../../../../i18n/i18n';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { UiContainer } from '../../../../state/ui';
import { ApiOrderItem, ApiProduct } from '../../../../types';
import './EditOrderProductBox.css';
import { ProductContainer } from '../../../../state/product';
import { productBadge } from '../../../../components/ProductListing/ProductBox/ProductBox';
import { useSession } from '../../../../state/session';

type EditOrderProductBoxProps = {
	product: ApiProduct;
	highlight?: boolean;
	className?: string;
	onChange: (item: ApiOrderItem) => void;
};

// TODO: Refaktorera denna så att den går att använda med productListing/ProductBox.tsx för att spara kod.
export const EditOrderProductBox = ({
	product,
	highlight,
	className,
	onChange,
}: EditOrderProductBoxProps): JSX.Element => {
	const {
		id,
		tcId,
		displayId,
		vendorId,
		vatRate,
		stocked,
		name,
		price,
		campaignPrice,
		image,
		bundleSize,
		perma,
		ecoLabels,
		deliveryClass,
		deliveryNotice,
		quantityInStock,
	} = product;
	const [quantityField, setQuantityField] = useState(bundleSize);
	const [added, setAdded] = useState(false);
	const t = useTranslation().form;
	const imgRef = useRef<HTMLImageElement>(null);
	const timer = useRef<ReturnType<typeof setTimeout>>();
	const ui = UiContainer.useContainer();
	const { getFinalPrice, specialPricesIndex } = ProductContainer.useContainer();
	const { user, specialsProductIds, isLoggedIn } = useSession();

	useEffect(() => () => clearTimeout(timer.current), []);

	function add() {
		const vatScale = ui.priceWithVat ? vatRate / 100 : 1;
		const orderItem = {
			id: 0,
			product: {
				id,
				tcId,
				displayId: parseInt(displayId),
				name,
				tax: vatScale,
				finalPrice: price,
				bundleSize,
				vendorId,
				deliveryClass,
				perma,
			},
			quantity: quantityField,
			stocked,
			stock: quantityInStock,
			image,
			trackingCategory: '',
		};

		setAdded(true);
		onChange(orderItem);
		timer.current = setTimeout(() => {
			setAdded(false);
		}, 3000);
	}

	const size = { width: 292, height: 292 };
	const hasSpecialPrice = !!getSpecialPrice(id);

	const isSpecialProduct = specialsProductIds.includes(id);
	const disabledProduct = user?.specialsOnly && !isSpecialProduct;
	const specialPriceProduct = specialPricesIndex ? specialPricesIndex[product.id] : undefined;

	return (
		<edit-order-product-box
			class={`${className ? className : ''} ${highlight ? 'highlight' : product.campaignPrice ? 'campaign' : ''}`}
		>
			{productBadge(hasSpecialPrice, campaignPrice > 0, false, specialPriceProduct, 'standard-badge-color')}
			<FavoriteButton id={product.id} />
			<EcoLabels ecoLabels={ecoLabels} isLoggedIn={isLoggedIn} size={22} />
			<Link to={'/' + perma} target="_blank" rel="noopener noreferrer" className="product-link">
				<Img
					ref={imgRef}
					alt={name}
					src={image}
					transparent={highlight}
					{...size}
					imgWidth={175}
					imgHeight={175}
				/>
				<div className="product-name">{name}</div>
				<div className="price-container">
					<PriceTagSimple
						price={getFinalPrice(id, price, 1, campaignPrice)}
						isCampaign={campaignPrice > 0}
						vatRate={product.vatRate}
						unit={product.unit}
					></PriceTagSimple>
					<DeliveryTime
						deliveryNotice={deliveryNotice}
						deliveryClass={deliveryClass}
						textLength={'short-one-line'}
					/>
				</div>
			</Link>
			<div className="buy-area">
				<div className="quantity-input">
					<QuantityInput
						iconSize={19}
						defaultValue={quantityField}
						step={bundleSize}
						onBlur={setQuantityField}
					/>
				</div>
				<Button disabled={added || disabledProduct} className="buy" onClick={() => add()}>
					{!added ? t.add : t.added}
				</Button>
			</div>
		</edit-order-product-box>
	);
};
